import styled from 'styled-components'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'

export const DimEffectOverlayer = () => {
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = ''
    }
  }, [])

  return createPortal(<OverLayer />, document.body)
}

const OverLayer = styled.div`
  inset: 0;
  z-index: 3;
  position: fixed;
  display: flex;
  align-items: center;
  overflow: auto;
  background-color: ${({ theme }) => `${theme.black}4D`};
`
